import BaseModel from 'models/BaseModel';

export default class AddressModel extends BaseModel {}
